
<ng-container *ngFor="let item of template">
  <app-skeleton-template *ngIf="item.multiple" [template]="item.items" [class]="item.classes" [style]="item.style"></app-skeleton-template>

  <div *ngIf="!item.multiple" [class]="item.classes" [style]="item.style">
    <ng-container *ngTemplateOutlet="elementTypes; context: {element: item}"></ng-container>
  </div>
</ng-container>

<ng-template #elementTypes let-element="element">
  <!-- <div [class]="element.classes" [style]="element.style">

  </div> -->
  <!-- tipo texto -->
  <nz-skeleton *ngIf="element.type === 'text'" [nzActive]="true" [nzParagraph]="{ rows: element.rows }"></nz-skeleton>
  <!-- tipo imagen -->
  <nz-skeleton-element *ngIf="element.type === 'image'" nzType="image" [nzActive]="true"></nz-skeleton-element>
  <!-- tipo input -->
  <nz-skeleton-element
    *ngIf="element.type === 'input'"
    nzType="input"
    [nzActive]="true"
    [nzSize]="'default'"
  ></nz-skeleton-element>
</ng-template>



